import { Vue } from 'vue-class-component';
export default class WLabel extends Vue {}